import axios from '../../../axios';
import IJobBoardSearchAccount from '../types/IJobBoardSearchAccount';

const url = '/candidatesearch/api/job-board-search-account/';

export const getNativeSearchAccountsForJobBoard = async (
  jobBoardName: string,
  country?: string
): Promise<IJobBoardSearchAccount[]> => {
  const response = await axios.get<IJobBoardSearchAccount[]>(`${url}${jobBoardName}`, {
    params: {
      country: country,
    },
  });
  return response.data;
};

export const fetchJobBoardByWorkspaceId = (jobBoard: string, workspaceId: string) =>
  axios.get(`${url}workspace?jobBoard=${jobBoard}&workspaceId=${workspaceId}`);
